import React from 'react';
import StatusPage from '../components/StatusPage';
export default function NotFound() { return <StatusPage title="404. A loose page." message="This page isn’t here. The rest of the notebook is." icon="book"/>; }
